export default "__VITE_ASSET__BAFz0Zvw__"